import styled from "styled-components";
import { COLORS, fontMixins } from "../../../styles";

export const SGCContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 236px;
`;

export const SGCImage = styled.div`
	display: flex;
	margin-bottom: 21px;
	border-radius: 10px;

	img {
		display: flex;
		width: 100%;
		border-radius: 10px;
	}
`;

export const SGCTitle = styled.div`
	display: flex;
	${fontMixins(22, 500)};
	margin-bottom: 28px;
	line-height: 29px;
`;

export const SGCIcon = styled.div`
	display: flex;
	margin-right: 12px;

	svg {
		width: 24px;
		height: 27px;
	}
`;

export const SGCDescription = styled.div`
	display: flex;
	${fontMixins(12)};
	color: #656772;
	line-height: 17px;
	margin-top: auto;
	margin-bottom: 14px;
`;

export const SGCPrice = styled.div`
	display: flex;
	${fontMixins(20, 600)};
	margin-bottom: 8px;
`;

export const SGCPriceDescription = styled.div`
	display: flex;
	${fontMixins(10, 400)};
	color: #9e8da3;
	margin-bottom: 25px;
`;

export const SGCPriceButton = styled.button`
	display: flex;
	${fontMixins(16, 500)};
	color: ${COLORS.White};
	background: ${COLORS.Gold};
	border: 0;
	border-radius: 4px;
	height: 42px;
	align-items: center;
	justify-content: center;
	cursor: pointer;
`;

export const SGCPurchasedBadge = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 100%;
	min-height: 40px;
	margin-top: auto;
	padding: 8px 14px;
	border-radius: 6px;
	background: #f7ead7;
	color: #9b6a2e;
	text-align: center;
`;

export const SGCPurchasedBadgeTitle = styled.span`
	font-size: 13px;
	font-weight: 700;
	line-height: 1.2;
`;

export const SGCPurchasedBadgeDate = styled.span`
	margin-top: 3px;
	font-size: 11px;
	font-weight: 500;
	line-height: 1.2;
	color: #9b6a2e;
	opacity: 0.85;
`;
